
import MaterialTable from "material-table"
import { forwardRef } from 'react'
import React from 'react'
import AddBox from '@material-ui/icons/AddBox'
import ArrowDownward from '@material-ui/icons/ArrowDownward'
import Check from '@material-ui/icons/Check'
import ChevronLeft from '@material-ui/icons/ChevronLeft'
import ChevronRight from '@material-ui/icons/ChevronRight'
import Clear from '@material-ui/icons/Clear'
import DeleteOutline from '@material-ui/icons/DeleteOutline'
import Edit from '@material-ui/icons/Edit'
import FilterList from '@material-ui/icons/FilterList'
import FirstPage from '@material-ui/icons/FirstPage'
import LastPage from '@material-ui/icons/LastPage'
import Remove from '@material-ui/icons/Remove'
import SaveAlt from '@material-ui/icons/SaveAlt'
import Search from '@material-ui/icons/Search'
import ViewColumn from '@material-ui/icons/ViewColumn'
import { usePlans, setOpenPlan, setPlan, setSelectedSOPs } from '../redux/plan'
import {setSelectedModule} from '../redux/navigation'
import { useToken } from "../redux/auth";
import {getSOPS, getFinal} from '../modules/db'

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
  }
  const handleClick = (event, rowData, token) => {
    setPlan({...rowData})
    setSelectedSOPs(rowData.sops)
    localStorage.setItem('plan', JSON.stringify({
      openPlan: true,
      plan: rowData,
      selectedModule: 'Organize',
    }))
    if( rowData.hasOwnProperty('process') && rowData.process.length > 0 ) {
      alert(`The plan ${rowData.name} has been loaded.`)
      setSelectedModule('Organize')
      setOpenPlan(true)
    } else {
      alert(`The plan ${rowData.name} has been loaded but it lacks process, please fill it and save the plan.`)
      getFinal(rowData.sops, token)
      setOpenPlan(true)
    } 
  }
const DataTable = () => {
    const token = useToken()
    getSOPS(token)
    const sops = usePlans()
    const datos = sops.map(function(x){
      return { 
        ...x,
        name:x.name, 
        writer:x.writer, 
        sopstitles:x.sops.map(x=>x.title).join(', ')
      }
    })
    return (
      <div>
        <MaterialTable
        columns={[
          { title: "Name", field: "name" },
          { title: "Location", field: "humantags.LOC" },
          { title: "Writer", field: "writer" },
          { title: "Process", field: "process" },
          { title: "Status", field: "status" },
        ]}
            
        data={datos}
        title="Click on a plan name to open it!"
        icons={tableIcons}
        options={{
          filtering: true,
          selection: false,
          search: true,
          pageSize:7,
          tableLayout:'fixed',
        }}
        onRowClick={(e, rowData) => handleClick(e,rowData, token)}
      />
      </div>
    )
  }
  
  export default DataTable